import script from "./UpLogUbica.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpLogUbica.vue?vue&type=script&lang=ts&setup=true"

import "./UpLogUbica.vue?vue&type=style&index=0&id=70a9080c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a9080c"]])

export default __exports__